import axios from "axios";

import { baseAxios } from "config";

const exportInvoiceSheet = async ({ invoiceId }) => {
  const res = await baseAxios.get(`/payroll/invoices/${invoiceId}/export`, {
    responseType: "blob",
  });
  return res;
};

export default exportInvoiceSheet;
